export const DASHBOARD_PROMO_HEIGHT = 60;
export const DEFAULT_REFERRAL_AMOUNT_IN_CENTS = 1000;

/**
 * Marks a deeplink value as carrying a promotion code rather than a route, e.g. the OneLink
 * deep link value `promoCode_STARTDATE50` applies `STARTDATE50`. Mirrors the mobile constant,
 * since both platforms are fed the same OneLinks.
 */
export const PROMO_CODE_DEEPLINK_PREFIX = "promoCode_";
